<div class="card"> 
   <div class="card-header card-no-border">
     <div class="header-top">
       <h5 class="m-0">{{ 'Views' | translate }}</h5>
       <div class="card-header-right-icon">
         <div class="dropdown">
           <button class="btn dropdown-toggle" type="button" (click)="toggle()">{{ 'Today' | translate }}</button>
           <div class="dropdown-menu dropdown-menu-end" [class.show]="show"><a class="dropdown-item" href="#">{{ 'Today' | translate }}</a><a class="dropdown-item" href="#">{{ 'Tomorrow' | translate }}</a><a class="dropdown-item" href="#">{{ 'Yesterday' | translate }}</a></div>
         </div>
       </div>
     </div>
   </div>
   <div class="card-body pt-0">
     <div class="view-container">
       <div id="view">
         <apx-chart [series]="views.series" [chart]="views.chart" [dataLabels]="views.dataLabels" [stroke]="views.stroke" [grid]="views.grid" [tooltip]="views.tooltip" [colors]="views.colors" [fill]="views.fill" [annotations]="views.annotations" [xaxis]="views.xaxis" [yaxis]="views.yaxis" [responsive]="views.responsive"></apx-chart>
      </div>
     </div>
   </div>
 </div>